import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../config/api';
import { 
  masterPageShell, 
  masterPanel, 
  masterInput, 
  masterInputLabel, 
  masterAccentButton, 
  masterSectionTitle 
} from './MasterCssClass';

const Login = ({ setToken }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/auth/login', { username, password });
      
      // Pass both token and username so App.js knows who logged in
      setToken(response.data.token, response.data.username);
      
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || err.response?.data?.error || 'Invalid username or password');
    }
  };

  return (
    <div className={`${masterPageShell} flex items-center justify-center h-screen`}>
      <div className={`${masterPanel} max-w-sm p-4`}>
        <h2 className={masterSectionTitle}>Login</h2>
        {error && <p className="text-[#FF6B6B] text-[10px] mb-2 font-bold text-center">{error}</p>}
        <form onSubmit={handleLogin} className="space-y-2">
          <div>
            <label className={masterInputLabel}>Username</label>
            <input 
              type="text" 
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
              className={masterInput}
              required 
            />
          </div>
          <div>
            <label className={masterInputLabel}>Password</label>
            <div className="relative">
              <input 
                type={showPassword ? "text" : "password"} 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                className={`${masterInput} pr-8`}
                required 
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 text-xs focus:outline-none"
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>
          <button type="submit" className={`${masterAccentButton} w-full justify-center mt-2`}>Login</button>
        </form>
      </div>
    </div>
  );
};

export default Login;